import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import Cta from '../../fragments/cta/Cta';
import RichText from '../../fragments/rich-text/RichText';

export default function Wysiwyg({ block, index }) {
  if (!block) return null;

  return (
    <ComponentWrapper className="BlockWysiwyg">
      <div className="l-grid">
        <RichText
          className={`l-grid__col l-grid__col--l-6-12 l-grid__col--l-push-3-12`}
          html={block.content}
        />
      </div>
    </ComponentWrapper>
  );
}
